<template>
  <div class="vue-menu-desktop" @mouseleave="onFocusOut">
    <div ref="topMenu" class="nav-menu">
      <a
        v-for="(item, i) in menuObj.slice(0, 10)"
        :href="item.href"
        :class="`nav-menu__item ${item === menu.focusInfo ? 'active' : ''}`"
        :style="item.color ? 'color:' + item.color + ';' : ''"
        @mouseover="onFocusIn(item)"
      >
        {{ item.name }}
      </a>
    </div>

    <transition name="fade">
      <div
        v-if="menu.focusInfo.items && menu.focusInfo.items.length > 0"
        :style="getTopMenuPosition"
        class="sub-menu__wrapper"
      >
        <div class="container">
          <div class="sub-menu">
            <div class="sub-menu__block">
              <ul v-for="list in menu.focusInfo.items" class="sub-menu__list">
                <li class="title" @mouseover="handlerGetViewImage(list)">
                  <a :href="list.href">{{ list.name }}</a>
                </li>
                <li v-for="item in list.items" class="item" @mouseover="handlerGetViewImage(item)">
                  <a :href="item.href">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            <img
              v-if="menu.focusImage && Object.keys(menu.focusImage).length > 0"
              class="sub-menu__banner"
              :src="menu.focusImage.src"
              :alt="menu.focusImage.alt"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'VueMenuDesktop',
  props: ['menuObj'],
  data() {
    return {
      menu: {
        focusInfo: {},
        focusImage: {},
      },
    };
  },
  computed: {
    getTopMenuPosition() {
      const menu = this.$refs.topMenu;
      // menu
      // console.log(getComputedStyle(menu));
      return { top: `${menu.offsetTop + menu.offsetHeight}px` };
    },
  },
  methods: {
    onFocusIn(item) {
      // console.log(item);
      this.menu.focusInfo = item;
      this.menu.focusImage = item.image;
    },
    onFocusOut() {
      this.menu.focusInfo = {};
    },
    handlerGetViewImage(item) {
      if (item && item.image) {
        this.menu.focusImage = item.image;
      }
    },
  },
};
</script>

<style lang="scss">
.vue-menu-desktop {
  font-weight: 400;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  .sub-menu {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    @include prefix(animation, fadein 0.7s);
    &__block {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }
    &__wrapper {
      position: absolute;
      z-index: 3;
      background-color: var(--background-colour-secondary);
      width: 100%;
      left: 0;
      top: 0;
      padding: 32px 50px;
      box-shadow: var(--box-shadow-primary-large);
      @include point-lg {
        padding: 15px 30px;
      }
    }

    &__list {
      width: 110px;
      max-width: 150px;
      margin-right: 50px;
      margin-bottom: 15px;
      > li {
        margin-bottom: 10px;
        @include point-lg {
          margin-bottom: 16px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &.title {
          font-weight: 500;
          text-transform: uppercase;
          color: var(--text-colour-secondary);
          @include point-lg {
            //font-size: rem(12);
            margin-top: 10px;
          }
          @include point-xl {
            font-size: rem(14);
            margin-top: 15px;
          }
        }

        &.item {
          font-weight: 300;
          @include point-lg {
            font-size: rem(12);
          }
          @include point-xl {
            font-size: rem(14);
          }

          > a {
            color: var(--hyperlink-colour-secondary);
            border-bottom: 1px solid transparent;
            //text-transform: capitalize;
            font-size: rem(16);
            font-weight: 400;
            @include prefix(transition, 0.3s ease-in);

            &:hover {
              border-bottom: 1px solid var(--border-colour-primary);
            }
          }
        }
      }
    }

    &__banner {
      margin-left: auto;
      @include point-md {
        display: none;
      }
      @include point-lg {
        display: block;
        //width: 400px;
        //height: 250px;
      }
      @include point-xl {
        display: block;
        //width: 450px;
        //height: 300px;
      }
    }
  }

  .nav-menu {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: space-between;

    &__item {
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      color: var(--text-colour-primary);
      font-size: rem(12);
      white-space: nowrap;
      justify-content: center;
      position: relative;
      padding: 15px 5px;
      @include prefix(transition, 0.3s ease-in);
      @include point-lg {
        padding: 18px 12px;
      }
      @include point-xl {
        padding: 18px 24px;
      }
      @include point-exl {
        font-size: rem(14);
      }

      &:after {
        content: '';
        height: 2px;
        display: block;
        position: absolute;
        left: 7px;
        bottom: 1px;
        width: calc(100% - 14px);
        background-color: var(--border-colour-primary);
        @include prefix(transition, 0.3s ease-in);
        @include prefix(transform, scaleX(0));
      }

      &.active {
        &:after {
          @include prefix(transform, scaleX(1));
        }
      }
    }
  }
}
</style>
